// Initialize AOS
AOS.init({
  duration: 800,
  easing: 'ease-out',
  once: true
});

// Page transition effect
document.addEventListener('DOMContentLoaded', () => {
  const pageTransition = document.querySelector('.page-transition');
  
  // Fade out on page load
  pageTransition.style.opacity = '1';
  pageTransition.style.visibility = 'visible';
  
  setTimeout(() => {
    pageTransition.style.opacity = '0';
    pageTransition.style.visibility = 'hidden';
  }, 500);
});

// Smooth scroll behavior
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});
